import WalletIcon from "@zenith/assets/icons/WalletIcon";
import { useMemo } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { QRCodeSVG } from "qrcode.react";
import { isOperationId } from "@zenith/utils/digitalReceipt";

const QRComponent = ({
  operationId,
  title = "Share Receipt",
  subtitle = "Customer can scan QR code to view receipt",
}: {
  operationId?: string | null;
  title?: string;
  subtitle?: string;
}) => {
  const walletIconDataUri = useMemo(() => {
    const markup = renderToStaticMarkup(<WalletIcon />);
    return `data:image/svg+xml;utf8,${encodeURIComponent(markup)}`;
  }, []);

  // Items without an operation carry a placeholder id the receipt page cannot open.
  const id = operationId?.trim() ?? "";
  if (!isOperationId(id)) return null;

  const receiptUrl = `${window.location.origin}/digital-receipt/${id}`;

  return (
    <div className="w-full">
      <div className="flex flex-col items-center rounded-2xl   bg-[#F4F4F4] p-6">
        <h3 className="text-center text-base font-bold text-neutral-900">
          {title}
        </h3>
        <p className="mt-1 mb-5 text-center text-xs text-neutral-500">
          {subtitle}
        </p>

        <div className="relative flex w-full   flex-col items-center justify-center rounded-xl border border-neutral-200/80 bg-white p-6 shadow-sm">
          <QRCodeSVG
            value={receiptUrl}
            size={220}
            level="H"
            imageSettings={{
              src: walletIconDataUri,
              height: 32,
              width: 32,
              excavate: true,
            }}
          />
          <p className="mt-4 text-center text-xs text-neutral-500">
            Scan to verify transaction details
          </p>
        </div>
      </div>
    </div>
  );
};

export default QRComponent;
